// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/fonts/fonts.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif; */
      font-family: "Rubik";
    
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.buttonBg {
  background: #386FE0;
  color: white;
  padding: 1rem 2rem;
  border-radius: 2rem;
  border: none;
  cursor: pointer;
  color:#fff;
  font-size: 1rem;
  text-decoration: none;
  font-weight: bold;
  text-transform: uppercase;
}

.addons_column-1, .addons_column-1_1, .addons_column-2_2, .addons_column-3_3, .addons_column-4_4, .addons_column-5_5, .addons_column-6_6, .addons_column-7_7, .addons_column-8_8, .addons_column-9_9, .addons_column-10_10, .addons_column-11_11, .addons_column-12_12 {
  width: 100%;
}

.addons_column-1_2, .addons_column-2_4, .addons_column-3_6, .addons_column-4_8, .addons_column-5_10, .addons_column-6_12 {
  width: 50%;
}

.addons_column-1_3, .addons_column-2_6, .addons_column-3_9, .addons_column-4_12 {
  width: 33.33333333%;
}

.addons_column-1_4, .addons_column-2_8, .addons_column-3_12 {
  width: 25%;
}

.addons_column-1_5, .addons_column-2_10 {
  width: 20%;
}

.addons_column-1_6, .addons_column-2_12 {
  width: 16.66666667%;
}

.loaderBg{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.loaderBg svg{
  width: 100px;
  height: 100px;
  margin: 20px;
  display:inline-block;
}
.container-not-found .center{width:800px; margin: 0 auto; position: absolute; top:50%; left: 50%; transform:translate(-50%, -50%)}
.container-fluid{width:90%; margin: 0 auto;}

.modal-content h4{ padding: 0.5rem; margin: 0 auto;}

.footer{
  width:100%; margin: 0 auto; padding: 1rem 0rem; background: #222024;
}
.footer .container{ width:1280px; }
.text-footer{color: #ffffff;}
.footer-right{ text-align: right;}

@media (max-width:560px){
  .addons_column-1_4, .addons_column-1_3{width:100%; margin-bottom: 1.5rem; padding-right:0px;}
  .container-not-found .center{width:100%}
  .footer, .footer-right{text-align: center;}
  .footer .container .addons_column-1_2 p {padding: 0;}
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AACA;EACE,SAAS;EACT;;iBAEe;MACX,oBAAoB;;EAExB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,oBAAoB;AACtB;AACA,6BAA6B,WAAW,EAAE,cAAc,EAAE,kBAAkB,EAAE,OAAO,EAAE,SAAS,EAAE,+BAA+B;AACjI,iBAAiB,SAAS,EAAE,cAAc,CAAC;;AAE3C,mBAAmB,eAAe,EAAE,cAAc,CAAC;;AAEnD;EACE,UAAU,EAAE,cAAc,EAAE,kBAAkB,EAAE,mBAAmB;AACrE;AACA,oBAAoB,YAAY,EAAE;AAClC,aAAa,cAAc,CAAC;AAC5B,eAAe,iBAAiB,CAAC;;AAEjC;EACE,uCAAuC,UAAU,EAAE,qBAAqB,EAAE,iBAAiB,CAAC;EAC5F,6BAA6B,UAAU;EACvC,uBAAuB,kBAAkB,CAAC;EAC1C,yCAAyC,UAAU,CAAC;AACtD","sourcesContent":["@import url('./assets/fonts/fonts.css');\nbody {\n  margin: 0;\n  /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif; */\n      font-family: \"Rubik\";\n    \n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.buttonBg {\n  background: #386FE0;\n  color: white;\n  padding: 1rem 2rem;\n  border-radius: 2rem;\n  border: none;\n  cursor: pointer;\n  color:#fff;\n  font-size: 1rem;\n  text-decoration: none;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.addons_column-1, .addons_column-1_1, .addons_column-2_2, .addons_column-3_3, .addons_column-4_4, .addons_column-5_5, .addons_column-6_6, .addons_column-7_7, .addons_column-8_8, .addons_column-9_9, .addons_column-10_10, .addons_column-11_11, .addons_column-12_12 {\n  width: 100%;\n}\n\n.addons_column-1_2, .addons_column-2_4, .addons_column-3_6, .addons_column-4_8, .addons_column-5_10, .addons_column-6_12 {\n  width: 50%;\n}\n\n.addons_column-1_3, .addons_column-2_6, .addons_column-3_9, .addons_column-4_12 {\n  width: 33.33333333%;\n}\n\n.addons_column-1_4, .addons_column-2_8, .addons_column-3_12 {\n  width: 25%;\n}\n\n.addons_column-1_5, .addons_column-2_10 {\n  width: 20%;\n}\n\n.addons_column-1_6, .addons_column-2_12 {\n  width: 16.66666667%;\n}\n\n.loaderBg{\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.loaderBg svg{\n  width: 100px;\n  height: 100px;\n  margin: 20px;\n  display:inline-block;\n}\n.container-not-found .center{width:800px; margin: 0 auto; position: absolute; top:50%; left: 50%; transform:translate(-50%, -50%)}\n.container-fluid{width:90%; margin: 0 auto;}\n\n.modal-content h4{ padding: 0.5rem; margin: 0 auto;}\n\n.footer{\n  width:100%; margin: 0 auto; padding: 1rem 0rem; background: #222024;\n}\n.footer .container{ width:1280px; }\n.text-footer{color: #ffffff;}\n.footer-right{ text-align: right;}\n\n@media (max-width:560px){\n  .addons_column-1_4, .addons_column-1_3{width:100%; margin-bottom: 1.5rem; padding-right:0px;}\n  .container-not-found .center{width:100%}\n  .footer, .footer-right{text-align: center;}\n  .footer .container .addons_column-1_2 p {padding: 0;}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
